export { default as dhangadhiLogo }             from "./dhangadhi-logo.svg"
export { default as defaultLogo }               from "./default-logo.svg"
export { default as nepaliFlag }                from "./nepali-flag.svg"
export { default as visitNepal }                from "./visit-nepal.jpg"
export { default as categoriesSprite }          from "./icons/categories_sprite.svg"
export { default as statusSprite }              from "./icons/status_sprite.svg"
export { default as headerSprite }              from "./icons/header_sprite.svg"
export { default as govLogo }                   from "./government-logo.png"
export { default as mellekhLogo }               from "./mellekh-logo.jpg"
